import { useUTLSettingsContext } from "@dexteel/mesf-core";
import { get } from "lodash-es";

import { CatalogDelayCodePage } from "./CatalogDelayCodePage";
import { ConfigurationDelayCodeProvider } from "./context/ConfigurationDelayCodeContext";
type Props = {
	delayAreaAssetName?: string;
};
const CatalogDelayCodes = (props: Props) => {
	const { state } = useUTLSettingsContext();
	const assetId = Number(
		get(state, `settings.${props.delayAreaAssetName}`, 10),
	);
	return (
		<ConfigurationDelayCodeProvider>
			<CatalogDelayCodePage
				delayAreaAssetId={assetId}
				delayAreaAssetName={props.delayAreaAssetName}
			/>
		</ConfigurationDelayCodeProvider>
	);
};

export default CatalogDelayCodes;
